import { StoreSeller } from '../../models';
import { Spinner } from '../ui/Spinner';
import { EmptyState } from '../ui/EmptyState';

export function SellerPicker({
  sellers,
  loading,
  selectedSeller,
  onSelect,
}: {
  sellers: StoreSeller[];
  loading: boolean;
  selectedSeller: StoreSeller | null;
  onSelect: (seller: StoreSeller) => void;
}) {
  return (
    <div className="mb-5">
      <p className="text-sm font-bold uppercase tracking-wide text-chocolate-dark mb-2">Vendedora</p>

      {loading ? (
        <div className="flex justify-center py-6">
          <Spinner size="md" />
        </div>
      ) : sellers.length === 0 ? (
        <EmptyState title="Nenhuma vendedora disponível no momento." />
      ) : (
        <div className="flex flex-col gap-2">
          {sellers.map((seller) => {
            const isSelected = selectedSeller?.id === seller.id;
            return (
              <button
                key={seller.id}
                type="button"
                onClick={() => onSelect(seller)}
                className={[
                  'w-full text-left bg-white rounded-xl p-4 shadow-sm flex items-center justify-between gap-3 border-2 transition-all min-h-[64px]',
                  isSelected ? 'border-chocolate' : 'border-transparent hover:border-champagne-dark',
                ].join(' ')}
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-champagne flex items-center justify-center text-chocolate font-bold text-base flex-shrink-0">
                    {seller.name.charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-text-dark">{seller.name}</p>
                    <p className="text-sm text-text-light">{seller.whatsAppPhone}</p>
                  </div>
                </div>
                {isSelected && (
                  <svg className="w-5 h-5 text-chocolate flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
